module.exports = __webpack_public_path__ + "images/logo_courtier_et_pret_cadre.548ad132.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/logo_courtier_et_pret_cadre.svg
// module id = 18
// module chunks = 0 1